export default __webpack_public_path__ + "static/media/GEI.953d2789.png";